
export enum OtpChannel {
  sms= 'sms',
  email= 'email',

}